import { render, staticRenderFns } from "./EnergyEfficiencyBox.vue?vue&type=template&id=2b9fc6d2&scoped=true&"
import script from "./EnergyEfficiencyBox.vue?vue&type=script&lang=js&"
export * from "./EnergyEfficiencyBox.vue?vue&type=script&lang=js&"
import style0 from "./EnergyEfficiencyBox.vue?vue&type=style&index=0&lang=css&"
import style1 from "./EnergyEfficiencyBox.vue?vue&type=style&index=1&id=2b9fc6d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9fc6d2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sebastian/Projekte/CD-Systeme/nextgenkonfi/konfiguratornextgen/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b9fc6d2')) {
      api.createRecord('2b9fc6d2', component.options)
    } else {
      api.reload('2b9fc6d2', component.options)
    }
    module.hot.accept("./EnergyEfficiencyBox.vue?vue&type=template&id=2b9fc6d2&scoped=true&", function () {
      api.rerender('2b9fc6d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/elements/EnergyEfficiencyBox.vue"
export default component.exports